import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { companyInfo, collageImages } from '../data';

export default function About() {
  const getServiceIdByTitle = (title) => {
    const t = title.toLowerCase();
    if (t.includes("sokkel") || t.includes("fundament")) return "sokkel";
    if (t.includes("terrændæk")) return "terraendaek";
    if (t.includes("belægning")) return "belaegning";
    if (t.includes("støttemur")) return "stoettemur";
    if (t.includes("gravearbejde")) return "gravearbejde";
    if (t.includes("nedbrydning")) return "nedbrydning";
    return null;
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 120;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="om" className="relative z-0 w-full bg-white pt-32 sm:pt-44 pb-20 sm:pb-28 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        
        {/* Left Column: Copy & Detailed Info */}
        <div className="flex flex-col text-left">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 uppercase tracking-tight leading-tight">
            {companyInfo.aboutTitle}
          </h2>
          <p className="mt-4 text-lg font-bold text-slate-800">
            {companyInfo.aboutSubtitle}
          </p>
          
          <div className="mt-6 space-y-4 text-slate-600 leading-relaxed">
            <p>{companyInfo.aboutDescription1}</p>
            <p>{companyInfo.aboutDescription2}</p>
          </div>

          {/* Bulleted List of Services */}
          <div className="mt-8">
            <h4 className="text-sm font-extrabold uppercase tracking-wider text-slate-900 mb-4">
              Nogle af de opgaver vi udfører til dagligt:
            </h4>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {companyInfo.servicesList.map((service, index) => {
                const serviceId = getServiceIdByTitle(service);
                return (
                  <li key={index} className="flex items-center gap-2.5 text-slate-700 font-medium">
                    <Check className="w-5 h-5 text-black shrink-0" />
                    {serviceId ? (
                      <Link
                        to={`/ydelser/${serviceId}`}
                        className="hover:text-sky-500 transition-colors hover:underline decoration-sky-500 decoration-2 underline-offset-4"
                      >
                        {service}
                      </Link>
                    ) : (
                      <span>{service}</span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          {/* CTA Button */}
          <div className="mt-10">
            <button
              onClick={() => scrollToSection('kontakt')}
              className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold uppercase text-xs tracking-wider py-4 px-6 transition-all duration-200 rounded-none shadow-md hover:shadow-orange-500/10 text-center cursor-pointer"
            >
              Kontakt os allerede i dag for en god aftale
            </button>
          </div>
        </div>

        {/* Right Column: Collage Image Grid */}
        <div className="flex flex-col gap-4">
          {/* Top Row: Large full-width image */}
          <div className="relative group overflow-hidden border border-slate-200 shadow-md">
            <img
              src={collageImages.top}
              alt="Terrændæk i Horsens"
              className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>

          {/* Bottom Row: 2 equal-sized images */}
          <div className="grid grid-cols-2 gap-4">
            <div className="relative group overflow-hidden border border-slate-200 shadow-md">
              <img
                src={collageImages.bottomLeft}
                alt="Støbning af sokkel"
                className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            <div className="relative group overflow-hidden border border-slate-200 shadow-md">
              <img
                src={collageImages.bottomRight}
                alt="Belægning til udendørs trappe"
                className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
